{
  "cycle.entite.attention_reports": "Reports d’éléments d’attention",
  "cycle.entite.conditions_acceptations": "Acceptations des conditions d’utilisation",
  "cycle.entite.confirmations_identite": "Confirmations d’identité",
  "cycle.entite.delegation_droits": "Droits transmis par délégation",
  "cycle.entite.exports_personnels": "Exports des données personnelles",
  "cycle.entite.favoris": "Espaces en favori",
  "cycle.entite.jetons_personnels": "Jetons personnels",
  "cycle.entite.preferences_affichage": "Préférences d’affichage",
  "cycle.entite.profils_personnels": "Profils personnels",
  "cycle.entite.recents": "Espaces visités récemment",
  "cycle.entite.statuts_personnels": "Statuts d’absence",
  "journalAudit.action.account.deletion_cancelled": "Suppression du compte annulée",
  "journalAudit.action.account.deletion_requested": "Suppression du compte demandée",
  "journalAudit.action.account.display_preferences_updated": "Préférences d’affichage modifiées",
  "journalAudit.action.account.export_created": "Export des données personnelles préparé",
  "journalAudit.action.account.export_downloaded": "Export des données personnelles téléchargé",
  "journalAudit.action.account.profile_updated": "Profil personnel modifié",
  "journalAudit.action.account.status_updated": "Statut d’absence modifié",
  "journalAudit.action.account.terms_accepted": "Conditions d’utilisation acceptées",
  "journalAudit.action.invitation.declined": "Invitation au projet ignorée"
}
